import { render } from "./gradeTypeOptCard.vue?vue&type=template&id=67688d49&scoped=true"
import script from "./gradeTypeOptCard.vue?vue&type=script&lang=js"
export * from "./gradeTypeOptCard.vue?vue&type=script&lang=js"

import "./gradeTypeOptCard.vue?vue&type=style&index=0&id=67688d49&scoped=true&lang=scss"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67688d49"]])

export default __exports__